import amplitude from 'amplitude-js';

class AnalyticsService {
  private initialized = false;

  init() {
    if (!this.initialized && process.env.NEXT_PUBLIC_AMPLITUDE_KEY) {
      amplitude.getInstance().init(process.env.NEXT_PUBLIC_AMPLITUDE_KEY);
      this.initialized = true;
    }
  }

  trackEvent(eventName: string, eventProperties?: any) {
    if (!this.initialized) {
      return;
    }
    amplitude.getInstance().logEvent(eventName, eventProperties);
  }

  // Helper method to identify users
  identifyUser(userId: string, userProperties?: object) {
    if (!this.initialized) {
      return;
    }

    // Set user ID
    amplitude.getInstance().setUserId(userId);

    // Set user properties if provided
    if (userProperties) {
      const identify = new amplitude.Identify();

      Object.entries(userProperties).forEach(([key, value]) => {
        identify.set(key, value);
      });

      amplitude.getInstance().identify(identify);
    }
  }
}

export const analytics = new AnalyticsService();

export default analytics;
